module.exports = __webpack_public_path__ + "static/img/1080-1920-3.87636f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tht/1080-1920-3.png
// module id = XGqH
// module chunks = 0